module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerMixin('Grid_Preloader', {
		configure: function() {
			this.registerOptions('', {
				skipPreloader: true,
				widgets: {
					stub: {
						widget: 'GridStub',
						'embed.widget': '@parent @parent @parent',
						manualRender: true,
						item: {
							title: 'My Scene',
							'_resources.primaryScene.url': '$env[design.url]/images/inactive/ph_video.jpg/w450i'
						},
						list: {
							skipPreloader: true
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		setupStubWidget: function() {
			this.registerOptions('#stub', {
				'embed.container': this.pw.getOption('embed.container') || this.pw.getOption('container'),
				'template': this.pw.getOption('template'),
				'list.tpl.row': this.getOption('list.tpl.row') || this.pw.getOption('list.tpl.row'),
				'list.container': this.pw.getOption('list.container'),
				'list.count': this.getOption('count')
			});

			if (this.getOption('item')) {
				this.registerOptions('#stub', {
					item: this.getOption('item')
				});
			}

		}
	}, 'Preloader');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/mixin/grid/preloader.js
// module id = 213
// module chunks = 0